/**
 * Force closes all current processes and reloads the page when the forbidden error occurs
 * This ensures clean state management and proper cleanup before reload
 * It Will inherit the current behavior from Rail View in the current implementation
 * Behavior:
 * - 403: Forbidden
 * When reload, it will redirect to the home page  and show flash message
 * - 401: Unauthorized
 * When reload, it will redirect to the list offices page and show flash message
 */

export const handleApprovingInvoiceReportForbiddenStatusCode = (
  statusCode?: number
) => {
  if (statusCode === 403 || statusCode === 401) {
    location.reload();
  }
};
